import React from "react";
import { BoxAd } from "@bloomberg/media-ui-ads";

import ErrorBoundary from "~components/ErrorBoundary";
import StoryImmersiveAd from "~components/StoryImmersiveAd";
import StoryInBodyAd from "~components/StoryInBodyAd";

import styles from "./styles.module.css";

type FeatureAdProps = {
    adType: string;
    positionIncrement?: number;
};

export default function FeatureAd({
    adType,
    positionIncrement,
}: FeatureAdProps) {
    if (adType === "leaderboard") {
        return (
            <div className={styles.featureImmersiveAd}>
                <StoryImmersiveAd positionIncrement={positionIncrement} />
            </div>
        );
    }

    // One of the ads below is hidden depending on viewport size. see styles
    return (
        <ErrorBoundary fallback="Failed to render feature ad">
            <div className={styles.featureBoxAd}>
                <BoxAd
                    positionIncrement={positionIncrement}
                    flexSizeAllowed={adType !== "small-box"}
                />
            </div>
            <div className={styles.featureInBodyAd}>
                <StoryInBodyAd positionIncrement={positionIncrement} />
            </div>
        </ErrorBoundary>
    );
}
